import { IntlProviderWrapper } from "./views/IntlContext";
import { StoreProvider } from "./views/StoreContext"
import SetFavicon from "./components/SetFavicon"
import RoutesPath from "./routes";
import "./styles/tailwind.css";
import "./App.css";





function App() {
  return (
    <StoreProvider>
      <IntlProviderWrapper>
        <SetFavicon />
        <RoutesPath />
      </IntlProviderWrapper>
    </StoreProvider>
  );
}

export default App;
